module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"UPS":"UPS","Account Number (6 digits)":"Account Nr. (sechsstellig)","UPS logout":"UPS ausloggen","UPS not logged in. Login happens while shipping packages.":"Nicht mit UPS eingeloggt. Der Login wird während des Versendens durchgeführt.","Logout successfully":"Logout erfolgreich"}}')
  delete Component.options._Ctor
}
